"use client";

import React from "react";
import type { InputProps } from "@/types";
import * as S from "./styles";
import LabelInput from "@/components/label";
import { PatternFormat } from "react-number-format";
import { NumericFormat } from "react-number-format";
import { useAuth } from "@/context/AuthContext";
import { getMaskCurrencyConfig } from "@/utils/formatCurrency";

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      placeholder,
      type = "text",
      hasShadow = false,
      label,
      validation,
      isPrice = false,
      isCep = false,
      isCpf = false,
      isCnpj = false,
      isPercentage = false,
      disabled,
      labelDescription,
      max,
      min,
      currency,
      ...rest // Pega onChange, onBlur, name, value, etc
    },
    ref,
  ) => {
    //const { currency } = useEstablishment();

    const { thousandSeparator, decimalSeparator, prefix } =
      getMaskCurrencyConfig(currency ?? "R$");

    return (
      <>
        {label && (
          <LabelInput labelInput={label} labelDescription={labelDescription} />
        )}
        {isPrice ? (
          <NumericFormat
            getInputRef={ref}
            className={className}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            prefix={`${prefix} `}
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            valueIsNumericString
            value={rest.value ?? ""}
            onValueChange={({ value }) => {
              if (rest.onChange) {
                rest.onChange({
                  target: {
                    name: rest.name || "",
                    value: value,
                  },
                });
              }
            }}
            customInput={S.InputComponent}
          />
        ) : isCep ? (
          <PatternFormat
            getInputRef={ref}
            className={className}
            format="#####-###"
            placeholder={placeholder || "00000-000"}
            value={rest.value}
            onValueChange={({ value }) => {
              if (rest.onChange) {
                rest.onChange({
                  target: {
                    name: rest.name || "",
                    value: value,
                  },
                });
              }
            }}
            customInput={S.InputComponent}
            disabled={!!disabled}
            {...rest}
          />
        ) : isCpf ? (
          <PatternFormat
            getInputRef={ref}
            className={className}
            format="###.###.###-##"
            placeholder={placeholder || "000.000.000-00"}
            value={rest.value}
            onValueChange={({ value }) => {
              if (rest.onChange) {
                rest.onChange({
                  target: {
                    name: rest.name || "",
                    value: value,
                  },
                });
              }
            }}
            customInput={S.InputComponent}
            disabled={!!disabled}
            {...rest}
          />
        ) : isCnpj ? (
          <PatternFormat
            getInputRef={ref}
            className={className}
            format="##.###.###/####-##"
            placeholder={placeholder || "00.000.000/0000-00"}
            value={rest.value}
            onValueChange={({ value }) => {
              if (rest.onChange) {
                rest.onChange({
                  target: {
                    name: rest.name || "",
                    value: value,
                  },
                });
              }
            }}
            customInput={S.InputComponent}
            disabled={!!disabled}
            {...rest}
          />
        ) : isPercentage ? (
          <NumericFormat
            getInputRef={ref}
            className={className}
            suffix="%"
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={false}
            allowNegative={false}
            valueIsNumericString
            value={rest.value ?? ""}
            onValueChange={({ value }) => {
              if (rest.onChange) {
                rest.onChange({
                  target: {
                    name: rest.name || "",
                    value: value,
                  },
                });
              }
            }}
            customInput={S.InputComponent}
            disabled={!!disabled}
            {...rest}
          />
        ) : (
          <S.InputComponent
            ref={ref}
            className={className}
            type={type}
            $hasShadow={hasShadow}
            placeholder={placeholder}
            validation={validation}
            disabled={!!disabled}
            {...rest} // Aplica todos os props de `register`
          />
        )}

        {validation?.type === "error" && (
          <S.ErrorMessage>{validation.message}</S.ErrorMessage>
        )}
      </>
    );
  },
);

Input.displayName = "Input";
export default Input;
